class statisticsProductListCtrl {
    constructor($scope, logger, httpRequest, treeSelectService, initSortService) {
        // 存储页面信息
        $scope.pageState = {
            idToken: localStorage.id_token,
            userInfo: JSON.parse(localStorage.user_info),
        }

        // 字典数据
        $scope.dictData = {}
        httpRequest.get_queryGoodsTax({
            taxMergeCode: -1,
            invType: -1,
        }).then((res) => {
            $scope.dictData.tax_rate = res.data.value
        })
        const typecodeArr = ['inv_type', 'invoice_status', 'is_red', 'source_object', 'specific_element']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })

        // 下拉机构组件配置
        $scope.queryOrgConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            queryType: 'statistTree',
            parentIdName: 'parentOrgId',
            multiple: true,
            parentId: $scope.pageState.userInfo.org.parentOrgId,
            defaultSelect: [],
        }
        // 下拉开票点
        $scope.queryUkeyConfig = {
            queryName: 'ukeyName',
            queryKey: 'ukeyId',
            queryType: 'Flater',
            parentIdName: 'parentUkeyId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }
        // 下拉销方
        $scope.querySaleConfig = {
            queryName: 'saleName',
            queryKey: 'saleId',
            queryType: 'Flater',
            parentIdName: 'parentSaleId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                invType: '',
                invoiceDateMax: initDate(),
                invoiceDateMin: initDate(),
                invoiceStatus: '',
                isRed: '',
                matName: '',
                orgIdList: [$scope.pageState.userInfo.user.currentOrgId],
                saleIdList: [],
                taxRate: '',
                ukeyIdList: [],
                invoiceCode: '',
                invoiceNumber: '',
                accessToken: $scope.pageState.idToken,
                billCode:''
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                invType: '',
                invoiceDateMax: initDate(),
                invoiceDateMin: initDate(),
                invoiceStatus: '',
                isRed: '',
                matName: '',
                orgIdList: [$scope.pageState.userInfo.user.currentOrgId],
                saleIdList: [],
                taxRate: '',
                ukeyIdList: [],
                invoiceCode: '',
                invoiceNumber: '',
                accessToken: $scope.pageState.idToken,
                billCode:''
            }
            $scope.queryOrgConfig.defaultSelect = defaultOrg
            $scope.queryUkeyConfig.defaultSelect = []
            $scope.querySaleConfig.defaultSelect = []
        }
        let defaultOrg = []
        // $scope.reset()
        // 时间格式初始化
        function initDate(day, month, year) {
            const date = new Date()
            const y = year || date.getFullYear()
            let m = month || date.getMonth() + 1
            let d = day || date.getDate()
            m = m < 10 ? `0${m}` : m
            d = d < 10 ? (`0${d}`) : d
            return `${y}-${m}-${d}`
        }

        // 表头排序
        $scope.orderMap = initSortService('staticPrdParam')
        $scope.selectedHandle = function selectedHandle() {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('staticPrdParam', JSON.stringify($scope.param))
            queryInfo()
        }

        $scope.$on('$stateChangeStart', (e, toState) => {
            if (toState.name.indexOf('statistics/outputStatistics/statisticsProduct') == -1) {
                sessionStorage.removeItem('staticPrdParam')
            }
        })

        // 查询展开
        $scope.isFilterCollapsed = false
        $scope.customizedConfig = {
            version: 1.4,
            queryConfig: [{
                label: '开票日期',
                selected: true,
                default: true,
            }, {
                label: '商品名称',
                selected: true,
                default: true,
            }, {
                label: '开票机构',
                selected: true,
                default: true,
            }, {
                label: '发票种类',
                selected: false,
                default: false,
            }, {
                label: '销方名称',
                selected: false,
                default: false,
            }, {
                label: '开票点',
                selected: false,
                default: false,
            }, {
                label: '发票性质',
                selected: false,
                default: false,
            }, {
                label: '发票税率',
                selected: false,
                default: false,
            }, {
                label: '发票号码',
                selected: false,
                default: false,
            }, {
                label: '发票状态',
                selected: false,
                default: false,
            }, {
                label: '发票代码',
                selected: false,
                default: false,
            },{
                label: '单据编号',
                selected: false,
                default: false,
            }, {
                label: '全电发票号码',
                selected: true,
                default: true,
            },
            {
                label: '发票来源',
                selected: true,
                default: true,
            },
            {
                label: '特定业务类型',
                selected: true,
                default: true,
            }, ],
            table: [{
                label: '税收分类编码',
                selected: true,
                default: true,
            }, {
                label: '商品名称',
                selected: true,
                default: true,
            }, {
                label: '简称',
                selected: true,
                default: true,
            }, {
                label: '合计金额/税额',
                selected: true,
                default: true,
            }, {
                label: '数量',
                selected: true,
                default: true,
            },{
                label: '单据编号',
                selected: true,
                default: true,
            }, {
                label: '发票种类',
                selected: true,
                default: true,
            }, {
                label: '发票号码',
                selected: true,
                default: true,
            }, {
                label: '发票代码',
                selected: true,
                default: true,
            }, {
                label: '购方名称',
                selected: true,
                default: true,
            }, {
                label: '开票日期',
                selected: true,
                default: true,
            }, {
                label: '开票机构',
                selected: true,
                default: true,
            }, {
                label: '税率',
                selected: false,
                default: false,
            }, {
                label: '单价',
                selected: false,
                default: false,
            }, {
                label: '销方名称',
                selected: false,
                default: false,
            }, {
                label: '销方信用代码',
                selected: false,
                default: false,
            }, {
                label: '开票点',
                selected: false,
                default: false,
            }, {
                label: '发票状态',
                selected: false,
                default: false,
            }, {
                label: '规格型号',
                selected: false,
                default: false,
            }, {
                label: '计量单位',
                selected: false,
                default: false,
            }, {
                label: '备注',
                selected: false,
                default: false,
            }, {
                label: '购方信用代码',
                selected: false,
                default: false,
            },{
                label: '全电发票号码',
                selected: true,
                default: true,
            },
            {
                label: '发票来源',
                selected: true,
                default: true,
            },
            {
                label: '特定业务类型',
                selected: true,
                default: true,
            },],
        }

        // 默认值
        $scope.orgList = [] // 机构
        $scope.ukeyList = [] // 开票点
        $scope.saleList = [] // 销方

        // 机构变化
        $scope.orgSelectChange = function (v) {
            const orgSelectArr = v
            const orgSelectL = orgSelectArr.length
            if (orgSelectL > 0) {
                $scope.param.param.orgIdList = orgSelectArr.map((item) => item.orgId)
            } else {
                $scope.param.param.orgIdList = []
            }
            $scope.param.param.ukeyIdList = []
            $scope.queryUkeyConfig.defaultSelect = []
            $scope.queryOrgConfig.defaultSelect = v
            httpRequest.post_qryUkeyListOfOrgIds($scope.param.param.orgIdList).then((res) => {
                if (res.data.success) {
                    $scope.ukeyList = treeSelectService(res.data.value, 'ukeyId', 'ukeyName')
                }
            })
        }

        // 开票点变化
        $scope.ukeySelectChange = function (v) {
            const ukeySelectArr = v
            const ukeySelectL = ukeySelectArr.length
            if (ukeySelectL > 0) {
                $scope.param.param.ukeyIdList = ukeySelectArr.map((item) => item.ukeyId)
            } else {
                $scope.param.param.ukeyIdList = []
            }
        }

        // 销方变化
        $scope.saleSelectChange = function (v) {
            const saleSelectArr = v
            const saleSelectL = saleSelectArr.length
            if (saleSelectL > 0) {
                $scope.param.param.saleIdList = saleSelectArr.map((item) => item.saleId)
            } else {
                $scope.param.param.saleIdList = []
            }
        }

        httpRequest.get_getUserOrgList().then((res) => {
            if (res.data.success) {
                $scope.orgList = res.data.value
                $scope.queryOrgConfig.defaultSelect = res.data.value.filter((item) => item.orgId === $scope.pageState.userInfo.user.currentOrgId)
                defaultOrg = res.data.value.filter((item) => item.orgId === $scope.pageState.userInfo.user.currentOrgId)
                // 返回机构名称
                $scope.fliterOrgName = function (id) {
                    if (id === null) {
                        return id
                    }
                    if (res.data.value === null) {
                        return id
                    }
                    const fliterUkeyNameArr = res.data.value.filter((item) => item.orgId === id)
                    if (fliterUkeyNameArr.length > 0) {
                        return fliterUkeyNameArr[0].orgName
                    }
                    return id
                }
                // 返回销方数组
                const _orgIdList = res.data.value.map((item) => item.orgId)

                // 开票点
                httpRequest.post_qryUkeyListOfOrgIds($scope.param.param.orgIdList).then((res) => {
                    if (res.data.success) {
                        $scope.ukeyList = treeSelectService(res.data.value, 'ukeyId', 'ukeyName')
                        queryInfo()
                    }
                })


                // 销方
                if (_orgIdList.length > 0) {
                    httpRequest.post_getSaleInfoListByOrgIds(_orgIdList).then((res) => {
                        $scope.saleList = treeSelectService(res.data, 'saleId', 'saleName')
                    })
                }
            }
        })

        // 导出
        $scope.exportInvoic = function () {
            const params = $.extend({},$scope.param.param)
            for (let i in $scope.param.orderMap) {
                params.sortField = i + ':' + $scope.param.orderMap[i]
            }
            // httpRequest.get_exportGoodsDetailToXLS(params)
            httpRequest.get_exportGoodsTax4DetailToXLS(params)
        }


        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数

        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('staticPrdParam', JSON.stringify({
                orderMap: $scope.param.orderMap,
                pageNum: $scope.param.pageNum,
                pageSize: $scope.param.pageSize,
                param: sessionStorage.staticPrdParam ? JSON.parse(sessionStorage.staticPrdParam).param : {
                    invType: '',
                    invoiceDateMax: initDate(),
                    invoiceDateMin: initDate(),
                    invoiceStatus: '',
                    isRed: '',
                    matName: '',
                    orgIdList: [$scope.pageState.userInfo.user.currentOrgId],
                    saleIdList: [],
                    taxRate: '',
                    ukeyIdList: [],
                    invoiceCode: '',
                    invoiceNumber: '',
                    accessToken: $scope.pageState.idToken,
                    billCode:''
                },
            }, ))
            queryInfo()
        }

        function queryInfo() {
            const invoiceDateMaxTmp = new Date($scope.param.param.invoiceDateMax)
            const invoiceDateMinTmp = new Date($scope.param.param.invoiceDateMin)
            if (overOneYear(invoiceDateMaxTmp, invoiceDateMinTmp)) {
                $scope.listData = []
                logger.logError('[开票日期]起始结束时间跨度不能超过一年')
                return
            }
            $scope.param = sessionStorage.staticPrdParam ? JSON.parse(sessionStorage.staticPrdParam) : $scope.param
            httpRequest.post_qryOpenedInvoiceGoodsTax4DetailList($scope.param).then((res) => {
                $scope.listData = res.data.value.list
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total
                $scope.param.pageNum = res.data.value.pageNum
                $scope.currentPage = ++res.data.value.prePage
                $scope.maxSize = res.data.value.pageSize
            })
        }

        function overOneYear(max, min) {
            const dateMaxTmp = new Date(max)
            const dateMinTmp = new Date(min)

            const dateMaxYear = dateMaxTmp.getFullYear()
            const dateMaxMonth = dateMaxTmp.getMonth()
            const dateMaxDay = dateMaxTmp.getDate()

            const dateMinYear = dateMinTmp.getFullYear()
            const dateMinMonth = dateMinTmp.getMonth()
            const dateMinDay = dateMinTmp.getDate()

            return (dateMaxYear - dateMinYear > 1) || (dateMaxYear - dateMinYear === 1) && (dateMaxMonth - dateMinMonth > 0) || ((dateMaxYear - dateMinYear > 0) && (dateMaxMonth - dateMinMonth === 0) && (dateMaxDay - dateMinDay > -1))
        }


        $scope.searchlist = function () {
            sessionStorage.setItem('staticPrdParam', JSON.stringify($scope.param))
            queryInfo()
        }
    }
}
statisticsProductListCtrl.$inject = ['$scope', 'logger', 'httpRequest', 'treeSelectService', 'initSortService']
export default statisticsProductListCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsProduct/statisticsProductListCtrl.js